import React from 'react';
import { IbanFormField } from '../../Fieldset/IbanFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { BankDetailsFormModel_MX } from './formModel';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { DropdownOption } from '../../Fieldset/fieldset.model';

const typeSafeFormFieldName = (formFieldName: keyof BankDetailsFormModel_MX) => formFieldName;

// Generates dropdown options for days 1 to 31.
export const createDayDropdownOptions: DropdownOption[] = Array.from({ length: 31 }, (_, i) => ({
  label: String(i + 1),
  value: String(i + 1),
}));

export const createFormInputs = (disableAllFormControls: boolean) => {
  return {
    iban: () => (
      <IbanFormField
        fieldName={typeSafeFormFieldName('iban')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="bankDetailsForm:fields:iban:label"
        placeholderTranslationKey="bankDetailsForm:fields:iban:placeholder"
      />
    ),
    bankAccountHolder: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('bankAccountHolder')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="bankDetailsForm:fields:bankAccountHolder:label"
        placeholderTranslationKey="bankDetailsForm:fields:bankAccountHolder:placeholder"
      />
    ),
    preferredPaymentDay: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('preferredPaymentDay')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="bankDetailsForm:fields:preferredPaymentDay:label"
        testId={typeSafeFormFieldName('preferredPaymentDay')}
        optionList={createDayDropdownOptions}
      />
    ),
  };
};
